import Vue from 'vue'
import store from './store'

var VueFire = require('vuefire')
var Firebase = require('firebase')

// explicit installation required in module environments
Vue.use(VueFire)

// Make Vue available globally (optional)
//window.Vue = Vue;

// Setup Firebase
var config = {
  apiKey: "AIzaSyCGcGUwVRBPh_X-pWG6z0BwYZG7RikHs3Q",
    authDomain: "running-year.firebaseapp.com",
    databaseURL: "https://running-year.firebaseio.com",
    storageBucket: "running-year.appspot.com",
    messagingSenderId: "687831310103"
}

Firebase.initializeApp(config)

var app = new Vue({
	el : '#app',
  data: {
    showNewPostModal: false
  },
	store,
	components : {
		'logo-header': require('./components/Header.vue'),
		'pledge' : require('./components/Pledge.vue'),
		'resources' : require('./components/Resources.vue')
	},
	created: function () {
      
      /*
      Firebase.auth().onAuthStateChanged(function(user) {
            
            console.log("hi");

          });
      */


    }
})

// create the app instance.
// here we store to all child components,
// making them available everywhere as `this.$store`.
/*
const app = new Vue(Vue.util.extend({
  store
}, App))
*/

// expose the app, the router and the store.
// note we are not mounting the app here, since bootstrapping will be
// different depending on whether we are in a browser or on the server.
export { app, store }


// WEBPACK FOOTER //
// ./src/main.js